import React from 'react'
import { EDIT_PROJECT_MODAL } from '@chegg-wt/core/state/modals/constants'
import { connect } from 'react-redux'
import { editCiteProject } from '@chegg-wt/core/state/projects/actions'
import { AppState } from '@chegg-wt/core/state'
import { modalDataSelector } from '@chegg-wt/core/state/modals/selectors'
import BaseProjectModal from '../BaseProjectModal'
import { MODAL_TITLE_EDIT_CITATION_LIST } from '../BaseProjectModal/types'
import { EditProjectModalProps } from './types'

export const EditProjectModal: React.FunctionComponent<EditProjectModalProps> = ({
  editProject,
  projectId,
  projectName,
  projectStyle,
}) => (
  <BaseProjectModal
    id={projectId}
    name={EDIT_PROJECT_MODAL}
    confirmText="Save"
    title={MODAL_TITLE_EDIT_CITATION_LIST}
    currentProjectName={projectName}
    currentProjectStyle={projectStyle}
    action={editProject}
    data-test="edit-modal"
  />
)

const mapStateToProps = (state: AppState) => ({
  projectName: modalDataSelector(state).name,
  projectStyle: modalDataSelector(state).style,
  projectId: modalDataSelector(state).id,
})

const mapDispatchToProps = {
  editProject: (defaultStyle, name, projectId) =>
    editCiteProject({
      defaultStyle,
      name,
      projectId,
      public: false, // we no longer have public projects, false by default
    }),
}

export default connect(mapStateToProps, mapDispatchToProps)(EditProjectModal)
